import { Briefcase } from "lucide-react";
import { employmentTypes } from "@/lib/jobFormOptions";

interface EmploymentTypeBadgeProps {
  type: string | null | undefined;
  className?: string;
}

export const EmploymentTypeBadge = ({ type, className }: EmploymentTypeBadgeProps) => {
  if (!type) return null;

  const label = employmentTypes.find((t) => t.value === type)?.label || type;

  return (
    <div className={`flex items-center gap-1.5 bg-foreground/[0.03] rounded-xl px-3 py-1.5 border border-foreground/[0.06] h-fit text-sm ${className || ""}`}>
      <Briefcase className="w-4 h-4 text-cyan" />
      <span className="text-sm font-bold text-foreground">{label}</span>
    </div>
  );
};
